<div>
  <div class="row">
    <div class="col-8">
      <div class="row row-cols-sm-auto mb-2">
        <form class="col-8">
          <div class="row">
            <div class="col-4 text-end">
              <bryntum-combo #deliveryDateFilterInput [autoExpand]="true" [items]="dateRangeFilterComboConfig.items"
                value [value]="dateRangeFilterComboConfig.value" [listeners]="dateRangeFilterComboConfig.listeners"
                [width]="dateRangeFilterComboConfig.width"></bryntum-combo>
            </div>
            <div class="col-4">
              <bryntum-date-range-field #dateFilterInput [value]="dateRangeConfig.value"
                [format]="dateRangeConfig.format" [autoExpand]="true" [listeners]="dateRangeConfig.listeners">
              </bryntum-date-range-field>
            </div>
          </div>
        </form>
        <button class="btn btn-secondary reset-button" (click)="resetFilters()">Reset</button>
        <button class="btn btn-secondary reset-button" (click)="toggleAllGroupings('expand')">
          Expand All <span><ng-icon size="1em" name="bootstrapArrowsAngleExpand"></ng-icon></span>
        </button>
        <button class="btn btn-secondary reset-button me-3" (click)="toggleAllGroupings('collapse')">
          Collapse All <span><ng-icon size="1em" name="bootstrapArrowsAngleContract"></ng-icon></span>
        </button>
        <span class="align-content-center badge bg-secondary fs-6 fw-light">
          Total Items: {{ totalItems }}
        </span>
      </div>
    </div>

    <div class="col-4 ">
      <div class="row">
        <div class="offset-6 col-2">
          <button class="btn btn-secondary" (click)="exportToCsv()">Export</button>
        </div>

        @if(userType === 0){
        <div class="col-4">
          <button class="btn btn-primary" (click)="createNewOrder()">Create New Order</button>
        </div>
        }
      </div>
    </div>

    @if(gridProps && !isInitializing){
    <bryntum-grid
      #orderSourceGrid
      [stateId]="gridStateId"
      [data]="data"
      [stateful]="gridProps.stateful!"
      [minHeight]="gridProps!.minHeight!"
      [columns]="gridProps.columns!"
      [filterBarFeature]="gridProps.filterBarFeature!"
      [cellEditFeature]="gridProps.cellEditFeature!"
      [excelExporterFeature]="gridProps.excelExporterFeature!"
      [listeners]="gridProps.listeners!"
      [store]="gridProps.store!"
      (onCellClick)="onCellClick($event)"
    >
    </bryntum-grid>
    }
  </div>
</div>
